import {AutomationFilter} from "./automation-filter";
import {AutomationTrigger} from "./automation-trigger";

export class AutomationConfiguration {
  trigger: AutomationTrigger;
  filters: AutomationFilter[];
  min_time_interval: number;

  static readonly MIN_TIME_INTERVAL_ONCE = 2 ** 31 - 1; // max of a signed 32-bit integer

  constructor(data: Partial<AutomationConfiguration>) {
    this.min_time_interval = data.min_time_interval;
    this.trigger = data.trigger ? new AutomationTrigger(data.trigger) : new AutomationTrigger({});
    this.filters = data.filters.map(f => new AutomationFilter(f));
  }

  public valid(): boolean {
    if (!this.minTimeIntervalValid()) {
      return false;
    }
    if (!this.filtersValid()) {
      return false;
    }
    if (!this.trigger || !this.trigger.valid()) {
      return false;
    }
    return true;
  }

  public filtersValid(): boolean {
    if (!this.filters || this.filters.length === 0) {
      return false;
    }
    return this.filters.every(f => f.valid());
  }

  public minTimeIntervalValid(): boolean {
    return this.min_time_interval != null && this.min_time_interval >= 0;
  }

  public asRequest(): Partial<AutomationConfiguration> | any {
    return {
      min_time_interval: this.min_time_interval,
      filters: this.filters.map(f => f.asRequest()),
      trigger: this.trigger.asRequest()
    };
  }
}
